import { DesignTokens, designTokensTh } from '@rbilabs/components-library';

import { primitive } from './primitives';

export const designTokens: DesignTokens = {
  ...designTokensTh,
  // Whitelabel-app-specific tokens to be added here, e.g.:
  // 'my-token-name': primitive.$black,
  'background-contrast-loyalty': '',
  'background-badge-cart-entry': primitive.$blackOpacity10,
  'background-icon-header-contrast': primitive.$whiteOpacity4,
  'background-inline-alert': primitive.$blackOpacity4,
  'background-menu-customization-image': '',
  'border-default': `1px solid ${primitive.$blackOpacity10}`,
  'icon-header-contrast': primitive.$white,
  'text-accent-order-number': primitive.th.$alwaysRed,
  'text-loyalty-highlight': '',
  'pickup-timed-fire-selector-button-background': primitive.$white,
  'tims-rewards-text-color': primitive.th.$coffeeBrown,
  'padding-list-item-group-header': `${primitive.$spacing6} ${primitive.$spacing4} ${primitive.$spacing2}`,

  // Global App Colors
  'top-nav-bar-background-color': primitive.th.$alwaysRed,
  'bottom-nav-bar-background-color': primitive.$white,
  'main-menu-carousel-background': primitive.$white,
  'bsm-default-background-color': primitive.th.$donutCreamLighten20,
  'bsm-in-progress-background-color': primitive.th.$coffeeBrown,
  'bsm-drop-shadow': '0 0 3px rgb(0 0 0 / 10%)',
};
